require('./dist/js/angular-aside');
module.exports = 'ngAside';


//////////////////
// WEBPACK FOOTER
// ./~/angular-aside/index.js
// module id = 46
// module chunks = 1